import { render } from "./GenproxModule.vue?vue&type=template&id=60261b87&ts=true"
import script from "./GenproxModule.vue?vue&type=script&lang=ts"
export * from "./GenproxModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__